import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-webportale',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './webportale.component.html',
  styleUrl: './webportale.component.scss'
})
export class WebportaleComponent { }
